module.exports = __webpack_public_path__ + "img/Computer Science.a8dfbbc2.svg";